// iimport PlaceholderImage from '../../atoms/placeholderImage';
import mergeClasses from '../../../../../utils/shallowMerge';
import PlaceholderImage from '../../../../atoms/placeholderImage/PlaceholderImage';
import defaultClasses from '../CartItem.module.scss';
import PropTypes from 'prop-types';
import React from 'react';
import { Image as CustomImage } from '../../../../atoms/image/Image';

const ProductImage = ({
  image,
  customClasses = null,
  alt,
  onClick = () => {},
  options
}) => {
  const styles = mergeClasses(defaultClasses, customClasses);

  const initialOptions = {
    crop: 'fill',
    width: 100 * 2,
    height: 125 * 2,
    quality: 'auto',
  };

  return (
    <div className={styles.productImage}>
      {image ? (
        <CustomImage
          onClick={onClick && onClick}
          alt={alt || 'Product image'}
          title={alt || 'Product image'}
          itemProp="image"
          className={styles.imageTile}
          image={image}
          opts={options || initialOptions}
        />
      ) : (
        <PlaceholderImage />
      )}
    </div>
  );
};

export default ProductImage;

ProductImage.propTypes = {
  customClasses: PropTypes.shape({}),
  onClick: PropTypes.func,
};
